// Selectable currencies for the 'currency' question type. Keep in sync with the
// backend list in backend/app/currency.py.
export const CURRENCIES = ['USD', 'GBP', 'EUR', 'CHF', 'JPY', 'SGD', 'HKD', 'AUD', 'CAD'];

export const CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: '£', USD: '$', EUR: '€', CHF: 'CHF ', JPY: '¥',
  SGD: 'S$', HKD: 'HK$', AUD: 'A$', CAD: 'C$',
};

// A stored currency answer: whole-number amount + the currency the applicant chose.
export interface CurrencyAnswer {
  amount: number | null;
  currency: string;
}

/** Render a stored currency answer as a display string (e.g. "£1,250,000"). */
export function formatCurrency(v: CurrencyAnswer | null | undefined): string {
  if (!v || v.amount == null || (v.amount as any) === '') return '';
  const n = Math.round(Number(v.amount));
  if (!Number.isFinite(n)) return '';
  const grouped = n.toLocaleString('en-US');
  const sym = CURRENCY_SYMBOLS[(v.currency || '').toUpperCase()];
  return sym ? `${sym}${grouped}` : `${grouped} ${v.currency || ''}`.trim();
}

/**
 * Render a plain `number` answer with thousands separators, preserving any
 * decimals the applicant entered (e.g. "1500000" -> "1,500,000",
 * "1234.5" -> "1,234.5"). Non-numeric input is returned unchanged so a stray
 * value is never dropped. Used for the `groupThousands` number field type.
 */
export function formatGrouped(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (raw === '') return '';
  const n = Number(raw.replace(/,/g, ''));
  if (!Number.isFinite(n)) return raw;
  const [intPart, fracPart] = raw.replace(/,/g, '').replace(/^[+-]/, '').split('.');
  const grouped = Number(intPart || '0').toLocaleString('en-US');
  const body = fracPart != null ? `${grouped}.${fracPart}` : grouped;
  return n < 0 ? `-${body}` : body;
}
